var e = Object.is || function (e, a) {
  return e === a ? 0 !== e || 1 / e == 1 / a : e != e && a != a;
};
export { e as s };